module.exports = __webpack_public_path__ + "img/AT0000002627659.00bc11d6.png";